import { useState, useEffect, useRef } from 'react';
import './style.scss';
import { listContent, listContentFile } from 'data/household';
import SidebarScroll, { Element } from '../../SidebarScroll';
import ImgPopup from '../../ImgPopup';
import { useLocation } from 'react-router-dom';

/* s: 221031 add */
import SwiperCore, { Swiper, Scrollbar } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

SwiperCore.use([Scrollbar]);
/* e: 221031 add */

const Household = () => {
  //   state switch
  const [isSwitch, setIsSwitch] = useState(false);

  const handleSwitch = () => {
    setIsSwitch(!isSwitch);
  };

  // SET UP ref to move component of sidebar
  const [toggleState, setToggleState] = useState(1);
  const [listCnt, setListCnt] = useState(listContent[0]);
  const [list] = useState(listContent);

  const [isImgPopupOpen, setIsImgPopupOpen] = useState(false);
  const [popupImg, setPopupImg] = useState('');
  const [popupTitle, setPopupTitle] = useState('');

  const handleClickImg = (img: string, title: string) => {
    setIsImgPopupOpen(true);
    setPopupImg(img);
    setPopupTitle(title);
  };

  const toggleTab = index => {
    setToggleState(index);
  };

  const infoRef = useRef<any>(null);
  const sliceRef = useRef<any>(null);

  useEffect(() => {
    setListCnt(list.find(val => val.id === toggleState) || list[0]);
  }, [toggleState, list]);

  const sidebarList = [
    { name: '특징', isActive: true },
    { name: '평면정보', isActive: true }
  ];

  const params = useLocation();
  const searchId = params.search.replace('?tabId=', '');

  useEffect(() => {
    if (searchId) {
      const changeIdData = listContent.map(item => {
        return { ...item, tit: item.tit.replace('㎡', '').replace('형', '').replace('평', '') };
      });
      const filterData = changeIdData.find(({ tit }) => tit === searchId);

      if (filterData) {
        setToggleState(filterData.id);
      }
    }
  }, [searchId]);

  // set up state of child slide
  const [startXChild, setStartXChild] = useState<any>(0);
  const [childIsDrag, setChildIsDrag] = useState(false);
  const ChildItems = document.getElementsByClassName('slide-items-child');
  const [childDragPos, setChildDragPos] = useState<any>(0);
  const [childWidth, setChildWidth] = useState(0);
  const [swiperWidth, setSwiperWidth] = useState(0);
  const [moveArr, setMoveArr] = useState<any>([]);
  const move = ChildItems[0]?.clientWidth;
  const MAX_SIZE = ChildItems.length * move - swiperWidth;
  const [moveTab, setMoveTab] = useState(0);
  const DRAG_SPPED = 1; //Drag Speed
  const TOTAL_SLIDE = (listContent.length - 1) * -1; //Total Slide child
  const isSlide = TOTAL_SLIDE > 7;
  const initSwiper = () => {
    const swiperWidth = document.getElementById('scrollChild')?.offsetWidth;
    const wrapWidth = document.getElementById('swiperWrap')?.offsetWidth;

    if (swiperWidth) setChildWidth(swiperWidth);
    if (wrapWidth) setSwiperWidth(wrapWidth);
  };

  //SET STATE FOR SIDEBAR FIXED
  useEffect(() => {
    initSwiper();
  }, []);

  const onChildMouseDown = (e: any) => {
    e.stopPropagation();
    if (isSlide) {
      setChildIsDrag(true);
      setStartXChild(e.clientX);
    }
  };

  const onChildMouseLeave = e => {
    e.stopPropagation();
    setChildIsDrag(false);
  };

  const onChildMouseUp = e => {
    e.stopPropagation();
    setChildIsDrag(false);

    setMoveArray(e);
  };

  const clamp = (val: number, min: number, max: number) => Math.min(Math.max(val, min), max);

  const setMoveArray = e => {
    const target = clamp(move * toggleState + childDragPos, MAX_SIZE, 0);

    let abs = 0;
    let min = moveArr[2];
    let near = 0;

    for (let i = 0; i < moveArr.length; i++) {
      abs = moveArr[i] - target < 0 ? moveArr[i] - target : -(moveArr[i] - target);

      if (abs > min) {
        min = abs;
        near = Math.floor(clamp(moveArr[i], MAX_SIZE, 0) / move);
      }
    }

    if (e.type !== 'mousemove') {
      setToggleState(near);

      setChildDragPos(0);
    }
  };

  const onThrottleDragMove = e => {
    e.stopPropagation();
    if (!childIsDrag) return;

    SetChildApproximateArray();
    setMoveArray(e);
    const walk = (e.clientX - startXChild) * DRAG_SPPED;

    if (!walk) {
      setChildDragPos(walk * -1);
    } else {
      setChildDragPos(walk);
    }
  };

  const SetChildApproximateArray = () => {
    const first = clamp(getTranstion('next'), MAX_SIZE, 0);
    const last = clamp(getTranstion('prev'), MAX_SIZE, 0);

    setMoveArr([first, childDragPos, last]);
  };

  const getTranstion = (type: string) => {
    if (type === 'next') {
      return Math.floor(((toggleState + 1) * move) / move) * move;
    } else {
      return Math.floor(((toggleState - 1) * move) / move) * move;
    }
  };

  const prevSlideChild = e => {
    e.stopPropagation();

    setMoveTab(moveTab - move);
  };

  const nextSlideChild = e => {
    e.stopPropagation();

    setMoveTab(moveTab + move);
  };

  /* s: 221031 add */
  useEffect(() => {
    interiorSwiper();
  }, []);

  const interiorSwiper = () => {
    new Swiper('#swiperInterior', {
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      },
      navigation: {
        prevEl: '.swiper-interior-button-prev-child',
        nextEl: '.swiper-interior-button-next-child',
        disabledClass: 'swiper-interior-button-disabled'
      },
      mousewheel: true,
      slidesPerView: 3,
      spaceBetween: 20
    });
  };
  /* e: 221031 add */

  return (
    <div className="contents-household-outline">
      <div className="content">
        <SidebarScroll sidebarList={sidebarList} />
        {/* START HERE  */}
        {sidebarList[0].isActive ? (
        <Element name={sidebarList[0].name}>
          <section className="section-title position-r pc-houseHold ">
            <div className="section-title-content t-center" id="#section-top">
              <div className="pc-houseHold-icon">
                <div className="icon"></div>
              </div>
              <h2 className="title">
                트렌디한 주거문화를 선도하는 혁신 주거평면 C2 House
              </h2>
              <p className="sub-title">'e편한세상 봉선 셀레스티지'에서 생활의 차이는 커지고 내일의 가치는 더 커집니다.</p>
            </div>
          </section>
        </Element>
        ) : null}

        {sidebarList[1].isActive ? (
        <Element name={sidebarList[1].name}>
          <section className="section-content" ref={sliceRef} id="sliceLocation">
            <div className="container">
              <div className="swiper-child-contaier">
                <div className="swiper-child" id="swiperWrap">
                  <div
                    id="scrollChild"
                    className="swiper-child-wrap"
                    onMouseDown={onChildMouseDown}
                    onMouseMove={onThrottleDragMove}
                    onMouseUp={onChildMouseUp}
                    onMouseLeave={onChildMouseLeave}
                    style={{
                      transitionDuration: `${childIsDrag ? 0 : 300}ms`,
                      transform: `translate3d(-${moveTab - childDragPos}px, 0px, 0px)`
                    }}>
                    {listContent.map((hContent, idx) => {
                      return (
                        <div
                          key={idx}
                          className={`slide-items-child ${toggleState === hContent.id ? 'tab active' : 'tab'}`}
                          onClick={() => toggleTab(hContent.id)}>
                          <a className="btn">{hContent.tit}</a>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div
                  onClick={prevSlideChild}
                  className={moveTab === 0 ? 'swiper-button-prev-child child-button-hidden' : 'swiper-button-prev-child'}
                />
                <div
                  onClick={nextSlideChild}
                  className={moveTab > MAX_SIZE ? 'swiper-button-next-child child-button-hidden' : 'swiper-button-next-child'}
                />
              </div>

              <div className="content-tabs">
                <div className="content-tab">
                  <div className="tab-header">
                    <div className="tab-header-content">
                      <div className="tab-header-left">
                        <h2 className="tab-header-tit">
                          {isSwitch ? listCnt.tit2 : listCnt.tit}
                          <span className="sub-tit">{listCnt.subtit}</span>
                        </h2>
                      </div>
                      <div className="tab-header-right">
                        <div className="tab-header-check">
                          <span className="tab-header-check-txt">㎡ (전용면적)</span>
                          <div
                            onClick={handleSwitch}
                            style={{ background: `${isSwitch ? '#ff671d' : '#eee'}` }}
                            className="slide-info-switch">
                            <span style={{ left: `${isSwitch ? '60%' : '0'}` }} className="switch-icon"></span>
                          </div>

                          <span className="tab-header-check-txt">평 (공급면적)</span>
                        </div>
                      </div>
                    </div>

                    <div className="tab-header-subtit">{listCnt.subtit2}</div>
                  </div>

                  <div className="tab-content">
                    <div className="tab-content-list">
                      <div className="tab-content-item">
                        <img src={listCnt.img1} alt="" />
                      </div>
                      <div className="tab-content-item popup" onClick={() => handleClickImg(listCnt.img2_big, '단지 배치도')}>
                        <img src={listCnt.img2} alt="" />
                      </div>

                      {listCnt.swiper.map((sp, index) => {
                        return (
                          <div className="tab-content-item" key={index}>
                            <img src={sp.img} alt="" />
                            {listCnt.footer ? <div className="tab-content-tit t-center">{sp.title}</div> : null}
                          </div>
                        );
                      })}
                      {/* <div className="tab-content-item center">
                        <img src={listCnt.img3} alt="" />
                      </div> */}
                    </div>
                  </div>

                  {/* 추가선택품목 */}
                  <div className="tab-footer">
                    <span className="txt01">추가선택품목</span>
                    <span className="txt02">
                      {listCnt.addInfo.split('\n').map((i, key) => {
                        return <div key={key}>{i}</div>;
                      })}
                    </span>
                  </div>

                  <div className="tab-footer">
                    <div className="tab-footer-container">
                      <div className="tab-footer-area">
                        <div className="tab-footer-tit">주거 전용면적</div>
                        <div className="tab-footer-cnt">{listCnt.residential_area}</div>
                      </div>
                      <div className="tab-footer-area">
                        <div className="tab-footer-tit">주거 공용면적</div>
                        <div className="tab-footer-cnt">{listCnt.common_residential_area}</div>
                      </div>
                      <div className="tab-footer-area">
                        <div className="tab-footer-tit">공급면적</div>
                        <div className="tab-footer-cnt">{listCnt.supply_area}</div>
                      </div>
                      <div className="tab-footer-area">
                        <div className="tab-footer-tit">기타 공용면적<br />(지하주차장등)</div>
                        <div className="tab-footer-cnt">{listCnt.other_common_areas}</div>
                      </div>
                      {/* <div className="tab-footer-area">
                        <div className="tab-footer-tit">지하주차장</div>
                        <div className="tab-footer-cnt">{listCnt.underground_parking_lot}</div>
                      </div> */}
                      <div className="tab-footer-area">
                        <div className="tab-footer-tit">계약면적</div>
                        <div className="tab-footer-cnt">{listCnt.contract_area}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 인테리어 */}
              {/* {listCnt.interiorDisplay ? 
              <div id="interior" className="content-interior">
                <h3 className='mb-45'>인테리어</h3>
                <div style={{ overflow: 'hidden' }} id="swiperInterior">
                  <div className="swiper-wrapper">
                    {listCnt.interiorSwiper.map((interior, index) => {
                      return (
                        <div key={index} className={'swiper-slide'}>
                          <div className="tab-content-item popup" onClick={() => handleClickImg(interior.img_big, interior.title)}>
                            <img src={interior.img} alt="" />
                          </div>
                          <div className="main-items-txt">{interior.title}</div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="swiper-footer-content-container">
                    <div className="swiper-scrollbar-container">
                      <div className="swiper-scrollbar"></div>
                    </div>

                    <div className="swiper-interior-button-container">
                      <button className={'swiper-interior-button-prev-child'}></button>
                      <button className={'swiper-interior-button-next-child'}></button>
                    </div>
                  </div>
                </div>
              </div>
              : null} */}

                {/* 유의문구 */}
                <div className="caution">
                  <p>
                  * 유니트 및 면적은 소비자의 이해를 돕기 위한 것으로 건축설계변경 및 그 이외의 사유로 변경될 수 있습니다.
                  </p>
                  <p>
                  * 본 제작물에 사용된 아이소메트릭 및 평면도는 소비자의 이해를 돕기 위한 것으로 건축설계변경 또는 그 외의 사유로 인해 변경될 수 있습니다.
                  </p>
                  <p>
                  * 일부 품목은 분양가 제외품목이오니 주택 전시관에서 반드시 확인하시기 바랍니다.
                  </p>
                  <p>
                  * 입면 디자인을 위해 발코니 턱, 발코니 샤시 및 난간 설치는 동일 평형이라도 호수별로 다르게 설계될 수 있습니다.
                  </p>
                  <p>
                  * 본 홍보물은 분양 승인 시 제출된 것으로 실제 시공시 변경될 수 있음을 유념하시기 바랍니다.
                  </p>
                </div>
            </div>
          </section>

          {/* 마감재 리스트, 주택형별 면적 확인 버튼 추가 */}
          <div className="line-download">
            {listContentFile.map((v, key) => {
              return (
                <div className="btn-wrap" key={key}>
                  <button className="btn-down" onClick={() => window.open(v.file, '_blank')}>
                    {v.title}
                  </button>
                </div>
              );
            })}
          </div>
        </Element>
        ) : null}
      </div>

      <ImgPopup title={popupTitle} img={popupImg} open={isImgPopupOpen} setOpen={setIsImgPopupOpen} />
    </div>
  );
};

export default Household;
